// extracted by mini-css-extract-plugin
export default {"container":"OK-z","title":"PK-z","link":"QK-z"};